module.exports = __webpack_public_path__ + "img/emp6-1.8b416657.jpg";